import { useTranslation } from 'react-i18next';

export default function MapCard() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6 h-full">
      {/* Map frame */}
      <div className="bg-[#111111] border border-white/5 rounded-2xl overflow-hidden flex-1 min-h-[420px] md:min-h-[520px]">
        {/* Map header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/5">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center bg-[#F57F25]/10 rounded-lg">
              <i className="ri-map-2-line text-[#F57F25] text-sm"></i>
            </div>
            <span className="text-white/70 text-xs font-semibold uppercase tracking-widest">{t('map_find_us')}</span>
          </div>
          <a
            href="https://maps.google.com/?q=1630+Broadway+Ave,+Boise,+Idaho+83706"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-[#F57F25] text-xs font-semibold hover:underline cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-xs"></i>
            </div>
            {t('map_open_maps_short')}
          </a>
        </div>

        {/* Embedded Google Map */}
        <div className="w-full h-full min-h-[360px] md:min-h-[460px]">
          <iframe
            title="Bucara Burger location – 1630 Broadway Ave, Boise Idaho"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2889.123456789!2d-116.20!3d43.60!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54aef8a1234567%3A0xabcdef1234567890!2s1630%20Broadway%20Ave%2C%20Boise%2C%20ID%2083706!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0, minHeight: '360px' }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-full"
          ></iframe>
        </div>
      </div>

      {/* Directions note */}
      <div className="flex items-start gap-3 bg-[#F57F25]/5 border border-[#F57F25]/15 rounded-xl px-5 py-4">
        <div className="w-8 h-8 flex items-center justify-center shrink-0 mt-0.5">
          <i className="ri-navigation-line text-[#F57F25] text-lg"></i>
        </div>
        <div>
          <p className="text-white/80 text-sm font-semibold mb-0.5">{t('map_directions_title')}</p>
          <p className="text-white/40 text-xs leading-relaxed">{t('map_directions_sub')}</p>
        </div>
      </div>

      {/* Get directions button */}
      <a
        href="https://maps.google.com/?q=1630+Broadway+Ave,+Boise,+Idaho+83706"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 bg-[#F57F25] hover:bg-[#e06d15] text-black font-bold text-sm py-4 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-navigation-fill text-base"></i>
        </div>
        {t('btn_get_directions')}
      </a>
    </div>
  );
}
